import { COLORS } from '@btime/constants'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useOpenEditTagModal } from '../../../utils/routes/modals/modalsActions'
import Button from '../../../packages/kiti/components/actions/Button'
import ControlBar from './ControlBar'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('tags')
  const openEditModal = useOpenEditTagModal()
  const canCreate = useSessionPermission('setupServiceOrderTag')

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <Title size="h4" color={COLORS.dark2} noMargin>
            {t('title')}
          </Title>
        </Col>

        <Col>
          <ControlBar />
        </Col>

        {canCreate && (
          <Col>
            <Button transparent onClick={() => openEditModal({})} size="small">
              {t('addNewButton')}
            </Button>
          </Col>
        )}
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
